function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import Loader from '../shared/Loader';
import { validateEmail } from '../../utils';
import { AuthenticationStyles } from './AuthenticationStyles';
export default function ForgotPassword(_ref) {
  var appProps = _ref.appProps,
    setAuthStep = _ref.setAuthStep;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hover = _useState6[0],
    setHover = _useState6[1];
  function handleSubmit() {
    if (email.length === 0) {
      appProps.flashMessage.show(appProps.translations.authentication.emailBlank, 'error');
    } else if (!validateEmail(email)) {
      appProps.flashMessage.show(appProps.translations.authentication.emailInvalid, 'error');
    } else {
      resetPassword();
    }
  }
  function resetPassword(event) {
    setLoading(true);
    var formData = new FormData();
    formData.append('account[email]', email);
    Rails.ajax({
      type: 'POST',
      url: appProps.resetPasswordPath,
      dataType: 'json',
      data: formData,
      success: function success(res) {
        if (res.message) {
          appProps.flashMessage.show(res.message, 'success');
          setEmail('');
        }
        setLoading(false);
      },
      error: function error(res) {
        appProps.flashMessage.show(res.error, 'error');
        setLoading(false);
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    style: AuthenticationStyles.authenticationWrapper,
    className: "flex-box flex-column items-center content-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "auth-box",
    style: AuthenticationStyles.authBox
  }, /*#__PURE__*/React.createElement("h1", {
    style: AuthenticationStyles.h1
  }, appProps.translations.authentication.loginTitle), /*#__PURE__*/React.createElement("div", {
    style: AuthenticationStyles.authBoxSubtitle
  }, appProps.translations.authentication.resetPasswordTitle), /*#__PURE__*/React.createElement("div", {
    className: "field",
    style: AuthenticationStyles.field
  }, /*#__PURE__*/React.createElement("label", null, appProps.translations.authentication.email), /*#__PURE__*/React.createElement("input", {
    style: AuthenticationStyles.input,
    type: "email",
    autoFocus: true,
    autoComplete: "email",
    placeholder: "some@example.com",
    value: email,
    onChange: function onChange(event) {
      return setEmail(event.target.value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: AuthenticationStyles.actions
  }, !loading ? /*#__PURE__*/React.createElement("div", {
    className: "flex-box items-center content-center"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "button",
    onClick: handleSubmit
  }, appProps.translations.authentication.resetPasswordButton)) : /*#__PURE__*/React.createElement(Loader, {
    size: 'medium',
    position: 'center'
  })), /*#__PURE__*/React.createElement("div", {
    style: AuthenticationStyles.actionLinks,
    className: "flex-box items-center content-space-between"
  }, /*#__PURE__*/React.createElement("a", {
    style: _objectSpread({
      color: hover === 'login' ? appProps.frontendStyles.general.bodyTextLink : appProps.frontendStyles.general.bodyText
    }, AuthenticationStyles.link),
    onMouseEnter: function onMouseEnter() {
      return setHover('login');
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      setAuthStep('login');
    }
  }, appProps.translations.authentication.loginButton), !appProps.disableRegistration && /*#__PURE__*/React.createElement("a", {
    style: _objectSpread({
      color: hover === 'register' ? appProps.frontendStyles.general.bodyTextLink : appProps.frontendStyles.general.bodyText
    }, AuthenticationStyles.link),
    onMouseEnter: function onMouseEnter() {
      return setHover('register');
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      setAuthStep('register');
    }
  }, appProps.translations.authentication.registerButton))));
}